module.exports = __webpack_public_path__ + "static/media/HCMM819.ff64c2cd.jpg";